export const ProgressStateConstant = {
    MAINPAGE : "",
    WORKFLOW : "workflow",
    WORKFLOW_NEW: "workflow_new"
}